import { FC, SVGProps } from 'react';

export const TicketsIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg
		version='1.1'
		id='Layer_1'
		xmlns='http://www.w3.org/2000/svg'
		xmlnsXlink='http://www.w3.org/1999/xlink'
		x='0px'
		y='0px'
		width='20'
		height='20'
		viewBox='0 0 20 20'
		xmlSpace='preserve'
		// style={{ enableBackground: 'new 0 0 20 20' }}
		{...props}
	>
		<g>
			<path
				fill='currentColor'
				d='M16.9,9.9h0.3c0.2,0,0.4-0.2,0.4-0.4V8.3c0-0.7-0.4-1.3-1.1-1.5l-1-3.2c-0.1-0.3-0.3-0.5-0.5-0.6
			c-0.2-0.1-0.5-0.1-0.8,0L4.8,6.7c0,0,0,0,0,0H4.6C3.7,6.8,3,7.5,3,8.3v1.2c0,0.2,0.2,0.4,0.4,0.4h0.3c0.6,0,1.1,0.5,1.1,1
			s-0.5,1-1.1,1H3.4C3.2,12,3,12.2,3,12.4v1.2c0,0.9,0.7,1.6,1.6,1.6H16c0.4,0,0.9-0.2,1.2-0.5c0.3-0.3,0.5-0.7,0.5-1.1v-1.2
			c0-0.2-0.2-0.4-0.4-0.4h-0.3c-0.3,0-0.6-0.1-0.8-0.3c-0.2-0.2-0.3-0.5-0.3-0.7C15.8,10.4,16.3,9.9,16.9,9.9z M7.1,6.8l7.4-2.9
			c0,0,0.1,0,0.1,0c0,0,0.1,0.1,0.1,0.1l0.9,2.8H7.1z M15,10.9c0,0.5,0.2,1,0.6,1.3c0.3,0.3,0.8,0.5,1.2,0.5v0.7
			c0,0.4-0.3,0.7-0.8,0.7H8.9v-0.2c0-0.2-0.2-0.4-0.4-0.4S8,13.8,8,14.1v0.2H4.6c-0.4,0-0.8-0.3-0.8-0.7v-0.7c1-0.1,1.8-0.9,1.8-1.9
			S4.9,9.1,3.8,9.1V8.3c0-0.4,0.3-0.7,0.8-0.7H8v0.2c0,0.2,0.2,0.4,0.4,0.4s0.4-0.2,0.4-0.4V7.6H16c0.4,0,0.8,0.3,0.8,0.7v0.7
			C15.8,9.1,15,9.9,15,10.9z'
			/>
			<path
				fill='currentColor'
				d='M8.4,11.3c-0.2,0-0.4,0.2-0.4,0.4v1.1c0,0.2,0.2,0.4,0.4,0.4s0.4-0.2,0.4-0.4v-1.1C8.9,11.5,8.7,11.3,8.4,11.3
			z'
			/>
			<path
				fill='currentColor'
				d='M8.4,8.6C8.2,8.6,8,8.8,8,9.1v1.1c0,0.2,0.2,0.4,0.4,0.4s0.4-0.2,0.4-0.4V9.1C8.9,8.8,8.7,8.6,8.4,8.6z'
			/>
		</g>
	</svg>
);
